const YOUTUBE_URL_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|shorts|watch)(?:\?(.*&)?v=|\S*\/))|youtu\.be\/)([a-zA-Z0-9_-]{11})/gi;
const VIMEO_URL_REGEX = /(?:http:\/\/)?(?:www\.)?(?:vimeo\.com)\/(.+)/g;
const TWITTER_URL_REGEX = /(?:https?:\/\/)?(?:(?:twitter\.com)|(?:x\.com))\/(.*)(\/status)\/(.+)/g;
const SPOTIFY_URL_REGEX = /^(?:https?:\/\/)?(?:play|open)\.spotify\.com\/(track|album|playlist|artist|show|episode)\/(.+)|https?:\/\/embed.spotify.com\/\?uri=spotify:(track|album|playlist|artist|show|episode):(.+)$/;
const parseUrlSafe = (url, base) => {
  try {
    return new URL(url, base);
  } catch {
    return null;
  }
};
function convertUrlToSpotifyEmbedUrl(url) {
  const match = url.match(SPOTIFY_URL_REGEX);
  if (!match) {
    return null;
  }
  if (url.includes("embed.spotify.com")) {
    return url;
  }
  const resourceType = match[1] || match[6];
  const resourceId = match[2] || match[7];
  return `https://open.spotify.com/embed/${resourceType}/${resourceId}`;
}

export { SPOTIFY_URL_REGEX, TWITTER_URL_REGEX, VIMEO_URL_REGEX, YOUTUBE_URL_REGEX, convertUrlToSpotifyEmbedUrl, parseUrlSafe };
//# sourceMappingURL=expandedResource.utils.js.map
